import React from 'react';

export default function IndexSectionApplication13() {
    return (
        <React.Fragment>
            <>
                <section className="pt-20">
                    <div className="container mx-auto px-4">
                        <div className="flex justify-center mb-6">
                            <div className="bg-yellow-100 py-1 px-2 text-xs font-bold inline-block">New feature</div>
                        </div>
                        <h1 className="font-heading text-center text-4xl lg:text-5xl font-bold max-w-2xl lg:max-w-5xl mx-auto mb-4">Create
                            your profile, follow friends, and stay tuned</h1>
                        <p className="text-gray-600 text-center max-w-xl mx-auto mb-6">Have you ever wondered how to
                            keep up with the best restaurants based on your friends suggestions?</p>
                        <div className="flex flex-wrap justify-center gap-4 mb-16">
                            <a className="inline-block" href="https://apps.apple.com/us/app/findameal/id6736911377">
                                <img src="cronos-assets/buttons/app-store.svg" alt/>
                            </a>
                            <a className="inline-block"
                               href="https://play.google.com/store/apps/details?id=ai.findameal">
                                <img src="cronos-assets/buttons/google-play.svg" alt/>
                            </a>
                        </div>
                        <div className="max-w-xl mx-auto">
                            <img className="w-full"
                                 src="https://static.shuffle.dev/uploads/files/91/912295578c198379538e8973cd408b5d4407df70/3-vert.png"
                                 alt/>
                        </div>
                    </div>
                </section>


            </>
        </React.Fragment>
    );
}

